import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { InstallerSearchCriteria } from './installer-search-criteria.interface';
import { InstallerChainSearchCriteria } from './installer-chain-search-criteria.interface';
import { InstallerChain } from '@shared/models/installer-chain';
import { CrudService } from '@shared/services/crud/crud.service';

export const DEFAULT_INSTALLERS_SEARCH_CRITERIA: InstallerSearchCriteria = {
  filters: {},
  sort: {
    field: 'name',
    direction: 'ASC'
  },
  pagination: {
    page: 1,
    perPage: 1000
  },
  removeInstallerWithoutCustomerLocation: false
};

const DEFAULT_INSTALLERS_CHAINS_SEARCH_CRITERIA: InstallerChainSearchCriteria = {
  filters: {},
  sort: {
    field: 'name',
    direction: 'ASC'
  },
  pagination: {
    page: 1,
    perPage: 1000
  }
};

@Injectable({
  providedIn: 'root'
})
export class InstallerChainService extends CrudService<InstallerChain, null, null> {
  constructor() {
    super();
    this.setFragment();
  }

  public fragment: any;
  public modelName = 'InstallerChain';
  private setFragment(fragment?: any): void {
    this.fragment =
      fragment ||
      gql`
        fragment fields on ${this.modelName} {
          _id
          name
        }
      `;
  }
}
